import * as React from 'react';

export interface ProgressBarProps {
    colors: any;
    hidePercentage?: boolean;
    max: number;
    min: number;
    prefix?: string;
    showValue?: boolean;
    style: React.CSSProperties;
    suffix?: string;
    value: number;
}

export class ProgressBar extends React.Component<ProgressBarProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    getColor(): string {
        const colors: any = this.props.colors || {};
        const limits: string[] = Object.keys(colors).sort((a: string, b: string) => +b - +a);
        const value: number = this.getPercentage();
        let color: string = null;

        for (let i: number = 0; i < limits.length; ++i) {
            if (value >= +limits[i]) {
                color = colors[limits[i]] || null;
                break;
            }
        }

        return color;
    }

    getPercentage(): number {
        const { max, min, value } = this.props;

        return min >= 0 && max > 0 && min <= max && value >= min && value <= max
            ? Math.floor((value / max) * 100) : 0;
    }

    getValue(): string {
        const percentage: string = !this.props.hidePercentage ? `${this.getPercentage()}%` : '';
        const prefix: string = this.props.prefix || '';
        const suffix: string = this.props.suffix || '';

        return `${prefix}${this.props.showValue ? this.props.value : percentage}${suffix}`;
    }

    render(): JSX.Element {
        return (
            <div style={{ position: 'relative', ...this.props.style || {} }}>
                <div style={{ textAlign: 'center', width: '100%', position: 'absolute', zIndex: 1 }}>
                    {this.getValue()}
                </div>
                <div style={{ backgroundColor: this.getColor(), width: `${this.getPercentage()}%`, transition: 'width 1s ease-in-out' }}>
                    &nbsp;
                </div>
            </div>
        );
    }
}
